import styled from 'styled-components'
import AvailabilityOriginal from 'components/Availability'

import edit from 'images/edit.svg'

export const Container = styled.div`
  display: block;
  flex: 1;
  flex-direction: column;
  align-items: stretch;
  overflow-y: auto;
`

export const InfoRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
`

export const Divider = styled.div`
  width: 90%;
  border-top: 1px solid #cbe1ea;
`

export const EmailAddressContainer = styled.div`
  font-size: 16px;
  font-weight: 500;
  margin: 20px 0;
  float: left;
  line-height: 25px;

  .email {
    /* margin: 0 10px; */
    padding: 5px;
    font-weight: bold;
    color: rgb(40, 89, 112);
    transition: 300ms ease;
    outline: none;
    border-radius: 4px;
    white-space: nowrap;
    text-align: left;
    box-sizing: border-box;
  }
  
  .editable {
    text-decoration: underline;
    background-color: white;
  }
`

export const UpdateButton = styled.a`
  font-weight: 600;
  background-color: #cbe1ea;
  color: #346C84;
  border-radius: 10px;
  font-size: 16px;
  padding: 6px;
  white-space: nowrap;
`

export const EditIcon = styled.img.attrs({
	src: edit,
})`
  width: 18px;
  vertical-align: middle;
  margin-right: 3px;
  margin-bottom: 4px;
`

export const Availability = styled(AvailabilityOriginal)`
  margin: 10px 0;
`

export const EmailInput = styled.input<{width: number}>`
  font-size: 16px;
  outline: none;
  border: none !important;
  -webkit-appearance: none;
  color: #262626;
  min-width: 50px;
  width: ${props => props.width * 8.8 + 'px'};
  cursor: text;
  font-size: 14px;
  font-weight: 300;
  text-align: center;
  background: #eef3f6;

`
